import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
var _dec, _class, _ColumnVisibilityDlg, _class2, _descriptor, _class3;
import * as AbReactResources from "abreact/generated/locale/AbReactResources";
import { DataGridColumn } from "abreact/incubator/ui/datagrid/DataGridColumn";
import { AbCheckbox } from "abreact/input/AbCheckbox";
import { AbDialog } from "abreact/popup/AbDialog";
import { AbList } from "absdk/commons/ui/input/AbList";
import { AbSelectionMode } from "absdk/commons/ui/input/AbSelectionMode";
import { action, observable, makeObservable } from "mobx";
import { observer } from "mobx-react";
import * as React from "react";
/**
 * Simple dialog class to support modifying the visibility of columns.
 * This dialog is invoked either by calling DataGrid.showColumnVisibilityDlg() or ColumnVisibilityMachine.showColumnVisibilityDlg().
 */
export let ColumnVisibilityDlg = (_dec = action.bound, _class = (_ColumnVisibilityDlg = class ColumnVisibilityDlg extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "listItems", void 0);
    this.listItems = this.initializeList(props.columnVisibilityMachine, props.columns);
    makeObservable(this);
  }
  initializeList(columnVisibilityMachine, columns) {
    let leafColumns = DataGridColumn.getLeafColumns(columns);
    return leafColumns.map(column => {
      return new ListItem(column, columnVisibilityMachine.isColumnFrozen(column));
    });
  }
  render() {
    let title = AbReactResources.columnVisibilityDlg_title();

    // Note that we can't define a className instead of direct CSS styles because we end up with a lower
    // specificity on the selector since AbDialog specifies a minWidth and minHeight so these won't take.
    let modalStyles = {
      width: 300,
      height: 250,
      minWidth: 250,
      minHeight: 200
    };
    return /*#__PURE__*/React.createElement(AbDialog, {
      title: title,
      resizable: true,
      style: modalStyles,
      okButton: AbReactResources.columnVisibilityDlg_closeButton()
    }, /*#__PURE__*/React.createElement(AbList, {
      items: this.listItems,
      selectionMode: AbSelectionMode.NONE,
      itemRenderer: item => /*#__PURE__*/React.createElement(ListItemRenderer, {
        item: item,
        onChange: this.onChangeColumnVisibility
      }),
      keyFunction: item => item.column.id
    }));
  }
  onChangeColumnVisibility(item, newValue) {
    // console.log("onItemClick");
    let column = item.column;
    if (!column.canHideColumn || this.props.columnVisibilityMachine.isColumnFrozen(column)) {
      return;
    }
    item.visible = newValue;
    if (newValue) {
      this.props.columnVisibilityMachine.showColumn(column);
    } else {
      this.props.columnVisibilityMachine.hideColumn(column);
    }
  }
}, _defineProperty(_ColumnVisibilityDlg, "defaultProps", {
  id: "ColumnVisibilityDlg"
}), _ColumnVisibilityDlg), _applyDecoratedDescriptor(_class.prototype, "onChangeColumnVisibility", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "onChangeColumnVisibility"), _class.prototype), _class);
let ListItem = (_class2 = class ListItem {
  constructor(column, isFrozen) {
    _defineProperty(this, "column", void 0);
    _defineProperty(this, "isFrozen", void 0);
    /**
     * This field shadows the column.visible value, but we want an observable value to make sure the AbCheckbox selected state is properly updated.
     */
    _initializerDefineProperty(this, "visible", _descriptor, this);
    this.column = column;
    this.isFrozen = isFrozen;
    this.visible = column.visible;
    makeObservable(this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class2.prototype, "visible", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class2);
let ListItemRenderer = observer(_class3 = class ListItemRenderer extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    let {
      item
    } = this.props;
    let tooltip = item.isFrozen ? AbReactResources.columnVisibilityDlg_frozenColumnTooltip() : undefined;
    return /*#__PURE__*/React.createElement(AbCheckbox, {
      value: item.visible,
      label: item.column.expandedName,
      style: {
        flex: "1 1 auto"
      },
      disabled: !item.column.canHideColumn || item.isFrozen,
      tooltip: tooltip,
      dataTestId: item.column.id,
      onChange: newValue => this.props.onChange?.(item, newValue)
    });
  }
}) || _class3;
//# sourceMappingURL=ColumnVisibilityDlg.js.map
